// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NBmPC8cXK0jaMVrWID4s{align-items:center;gap:8px;padding:10px 0;display:flex}.QPoIr26rXsfOvoSSPQBk{flex-direction:column;gap:4px;min-width:0;display:flex}.trS0FOm082IKktL_xdkw{align-items:center;gap:12px;display:flex}.gB47TjZz9pkMJrIwBPmu{background-color:var(--gray-a-15);border:none;padding:4px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"name": `NBmPC8cXK0jaMVrWID4s`,
	"nameInfo": `QPoIr26rXsfOvoSSPQBk`,
	"email": `trS0FOm082IKktL_xdkw`,
	"inviteIcon": `gB47TjZz9pkMJrIwBPmu`
};
export default ___CSS_LOADER_EXPORT___;
